<template>
  <div class="container">
    <PublicHeader :totalName="$t('position').title" />
    <!-- 订单详情 -->
    <div class="orderInfoss">
      <!-- 名称 -->
      <div class="item">{{ $t('position').product }}<span>{{ orderInfo.name }}</span></div>
      <!-- 方向 -->
      <div class="item" v-if="orderInfo.productBusiness == 3">{{ $t('position').direction }}<span>{{ orderInfo.buyDirection == '0' ?
                  $t('trade').buyBtn : $t('trade').sellBtn}}</span></div>
      <div class="item" v-else>{{ $t('position').direction }}<span>{{ orderInfo.buyDirection == '0' ?
                  $t('trade').Kato : $t('trade').Openempty }}</span></div>
      <!-- 杠杆倍数 -->
      <div class="item" v-if="orderInfo.productBusiness != 3">{{ $t('position').Leverageratio }}<span>{{ orderInfo.lever }} X</span></div>
      <!-- 当前价格 -->
      <div class="item">{{ $t('position').Currentprice }}<span :class="orderInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ orderInfo.newPrice }} ({{orderInfo.priceChangeRatio}}%)</span></div>
      <!--  止盈价-->
      <div class="item" v-if="orderInfo.stopSurplusPrice">{{ $t('position').stopSurplusPrice }}<span>{{ orderInfo.stopSurplusPrice }}</span></div>
      <!-- 止损价 -->
      <div class="item" v-if="orderInfo.stopLossPrice">{{ $t('position').Stoplossprice }}<span>{{ orderInfo.stopLossPrice }}</span></div>
      <!-- 委托价 -->
      <div class="item">{{ $t('position').Entrustedprice }}<span>{{ orderInfo.price }}</span></div>
      <!-- 委托数量 -->
      <div class="item">{{ $t('position').Entrustednum }}<span>{{ orderInfo.quantity }}</span></div>
      <!-- 保证金 -->
      <div class="item" v-if="orderInfo.productBusiness != 3">{{ $t('position').margin }}<span>{{ orderInfo.margin }}</span></div>
      <!-- 手续费 -->
      <div class="item" v-if="orderInfo.productBusiness != 3">{{ $t('position').changeRate }}<span>{{ orderInfo.changeRate }}</span></div>
      <!-- 市值 -->
      <div class="item" v-if="orderInfo.status != '3' &&orderInfo.productBusiness != 3">{{ $t('position').marketvalue }}<span>{{ (orderInfo.newPrice * orderInfo.quantity).toFixed(6).replace(/\.?0+$/, '') }}</span></div>
      <!-- 订单金额 -->
      <div class="item" v-if="orderInfo.productBusiness != 3">{{ $t('position').orderAmount }}<span>{{ orderInfo.amount }}</span></div>
      <!-- 订单号 -->
      <div class="item">{{ $t('position').orderno }}<span>{{ orderInfo.orderNo }}<svg-icon class-name="svgs" icon-class="copy" @click="onCopy(orderInfo.orderNo)" /></span></div>
      <!-- 委托时间 -->
      <div class="item">{{ $t('position').Entrustedtime }}<span>{{ orderInfo.createTime | getLocalTime }}</span></div>
      <!-- 盈亏 -->
      <div class="item" v-if=" orderInfo.status != '3' && orderInfo.productBusiness != 3 && orderInfo.profitAmount_new">{{ $t('position').profitloss }}<span :class="orderInfo.profitAmount_new > 0 ? 'green' : 'red'">{{ orderInfo.profitAmount_new }}</span></div>
      <!-- 盈亏百分比 -->
      <div class="item" v-if="orderInfo.status != '3' && orderInfo.productBusiness != 3 && orderInfo.profitRate_new">{{ $t('position').profitloss }}%<span :class="orderInfo.profitRate_new > 0 ? 'green' : 'red'">{{ orderInfo.profitRate_new }}%</span></div>
      <!-- 盈亏 -->
      <div class="item" v-if="orderInfo.status == '3' && orderInfo.productBusiness != 3">{{ $t('position').profitloss }}<span :class="orderInfo.profitAmount > 0 ? 'green' : 'red'">{{ orderInfo.profitAmount }}</span></div>
      <!-- 盈亏百分比 -->
      <div class="item" v-if="orderInfo.status == '3' && orderInfo.productBusiness != 3">{{ $t('position').profitloss }}%<span
          :class="orderInfo.profitAmount > 0 ? 'green' : 'red'">{{ (orderInfo.profitAmount/orderInfo.margin* 100).toFixed(2).replace(/\.?0+$/, '') }}%</span></div>
      <!-- 结算价格 -->
      <div class="item" v-if="orderInfo.status == '3' && orderInfo.productBusiness != 3">{{ $t('position').SettlementPrice }}<span>{{ orderInfo.salesPrice }}</span></div>
      <!-- 结算时间 -->
      <div class="item" v-if="orderInfo.status == '3' && orderInfo.productBusiness != 3">{{ $t('position').Settlementtime }}<span>{{ orderInfo.salesTime | getLocalTime }}</span></div>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'
import { webSocket } from "@/mixins/webSocket.js";

export default {
  mixins: [webSocket],
  components: {
    PublicHeader
  },
  data() {
    return {
      orderInfo: {},
      orderId: null,
    }
  },
  mounted() {
    if (this.$route.query.i) {
      this.orderId = this.$route.query.i
      this.getOrderInfo()
    }
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
    clearInterval(this.timer);
  },
  methods: {
    // 定期详情
    async getOrderInfo() {
      const res = await orderApi.getOrderInfo({ orderId: this.orderId })
      this.orderInfo = res.data
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送列表
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: [that.orderInfo.symbol]
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 订单详情
        let quoteInfos = reslult.find(item => item.Symbol == that.orderInfo.symbol);
        if (quoteInfos) {
          that.$set(that.orderInfo, 'newPrice', quoteInfos.NewPrice)
          that.$set(that.orderInfo, 'priceChangeRatio', quoteInfos.PriceChangeRatio)
          // 非历史成交订单
          if (that.orderInfo.status != '3' && that.orderInfo.productBusiness != '3') {
            // 盈亏=持仓订单(产品价格-购买单价)【绝对值】x数量
            var profit = (Math.abs(that.orderInfo.price - quoteInfos.NewPrice) * that.orderInfo.quantity)
            //买涨 价格下跌
            if (that.orderInfo.buyDirection == '0' && that.orderInfo.price > quoteInfos.NewPrice)
              profit = -profit
            //买跌 价格上涨
            if (that.orderInfo.buyDirection == '1' && that.orderInfo.price < quoteInfos.NewPrice)
              profit = -profit
            //盈亏要减去手续费
            that.$set(that.orderInfo, 'profitAmount_new', (profit - that.orderInfo.changeRate).toFixed(4).replace(/\.?0+$/, ''))
            that.$set(that.orderInfo, 'profitRate_new', (that.orderInfo.profitAmount_new / that.orderInfo.margin * 100).toFixed(2).replace(/\.?0+$/, ''))
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .orderInfoss {
    padding: 50px 15px 20px 15px;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: var(--background_color);
      background: var(--text_color);
    }

    .btns {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .b1 {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--text_color);
        background: var(--info_color);
      }

      .b2 {
        margin-left: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--background_color);
        background: var(--text_color);
      }
    }
  }
}
</style>
